import React, { useEffect, useRef } from 'react';

const AnimatedBubbles = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    let animationFrameId;

    const resizeCanvas = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };

    window.addEventListener('resize', resizeCanvas);
    resizeCanvas();

    const bubbles = [];
    const numBubbles = 50; // Cantidad de burbujas
    const minRadius = 5;
    const maxRadius = 20;
    const minSpeed = 0.5;
    const maxSpeed = 2;

    class Bubble {
      constructor() {
        this.radius = Math.random() * (maxRadius - minRadius) + minRadius;
        this.x = Math.random() * canvas.width;
        this.y = canvas.height + this.radius; // Empiezan desde abajo
        this.speed = Math.random() * (maxSpeed - minSpeed) + minSpeed;
        this.opacity = Math.random() * 0.5 + 0.2; // Opacidad entre 0.2 y 0.7
        this.color = `rgba(135, 206, 250, ${this.opacity})`; // Azul claro
      }

      draw() {
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2);
        ctx.fillStyle = this.color;
        ctx.fill();
      }

      update() {
        this.y -= this.speed;
        // Reiniciar burbuja si sale de la pantalla
        if (this.y < -this.radius) {
          this.y = canvas.height + this.radius;
          this.x = Math.random() * canvas.width;
          this.radius = Math.random() * (maxRadius - minRadius) + minRadius;
          this.speed = Math.random() * (maxSpeed - minSpeed) + minSpeed;
          this.opacity = Math.random() * 0.5 + 0.2;
          this.color = `rgba(135, 206, 250, ${this.opacity})`;
        }
      }
    }

    for (let i = 0; i < numBubbles; i++) {
      bubbles.push(new Bubble());
    }

    const animate = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      bubbles.forEach(bubble => {
        bubble.update();
        bubble.draw();
      });
      animationFrameId = requestAnimationFrame(animate);
    };

    animate();

    return () => {
      window.removeEventListener('resize', resizeCanvas);
      cancelAnimationFrame(animationFrameId);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      className="fixed top-0 left-0 w-full h-full z-0 pointer-events-none"
      style={{ background: 'linear-gradient(to bottom, #E0F7FA, #B3E5FC)' }} // Fondo degradado de agua
    />
  );
};

export default AnimatedBubbles;